// @flow
import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import classnames from 'classnames'
import semver from 'semver'

import { Flex } from 'components/common'
import { useI18n } from '~/core/i18n'
import { useGlobalContext } from '~/core/context'
import { LanguageSelect } from './languageSelect'

import type { Page } from './types.flow'
type TopbarProps = {
  actualPage: Page | null,
  actualPath: string
}

const Topbar = ({ actualPage, actualPath, ...props }: TopbarProps) => {
  const [msg] = useI18n()
  const { pbx } = useGlobalContext()
  const subpages: any[] = Object.values(actualPage?.subpages || {})

  return actualPage ? (
    <header className="callcntr_header" {...props}>
      <article className="top-bar">
        <section className="top-bar_section-secondary">
          <i className="icon icon-m sidebar-app_nav_item_icon" style={{ marginLeft: '10px' }}>
            {actualPage.icon}
          </i>
        </section>
        <section className="top-bar_section-primary">
          <div className="top-bar_menu">
            <h2 className="no-mrg text-normal">{msg(actualPage.title)}</h2>
          </div>
          <div className="top-bar_divider" />
          <div className="top-bar_menu">
            {subpages.map(({ path, title, version, disabled }) => {
              if (disabled) {
                return null
              }

              if (version && !semver.satisfies(pbx.version, version)) {
                return null
              }

              return (
                <Link key={path} href={path}>
                  <a
                    className={classnames('top-bar_menu-item', {
                      active: actualPath.includes(path)
                    })}
                    style={{
                      fontSize: 14
                    }}
                  >
                    {msg(title)}
                  </a>
                </Link>
              )
            })}
          </div>
        </section>
        <section className="top-bar_section-actions">
          <Flex alignCenter justifyEnd spacing={2}>
            <LanguageSelect />
            {actualPage.docs && (
              <a
                className="btn btn-flat"
                href={actualPage.docs}
                rel="noopener noreferrer"
                target="_blank"
                title={msg('common.topbar.help')}
              >
                <i className="icon icon-m">help</i>
              </a>
            )}
          </Flex>
        </section>
      </article>
    </header>
  ) : null
}

Topbar.propTypes = {
  actualPage: PropTypes.object,
  actualPath: PropTypes.string.isRequired
}

export { Topbar }
